<template>
    <ModelIndexLayout
        :modelNamePlural="__('admin::settings.settings')"
    >

        <Panel>

            <form @submit.prevent="submit">

                <FormGroup
                    v-for="(item, key) in settingOptions"
                    :key="key"
                    :label="item.name"
                >
                    <span class="block text-xs italic -mt-0.5 pb-2" v-if="item.description" v-text="item.description" />
                    <Textarea :rows="2" v-model="form.settings[key]" :required="false" />
                </FormGroup>

                <Button :loading="form.processing">
                    {{ __('admin::general.update_model', {'model': __('admin::settings.settings').toLowerCase() }) }}
                </Button>

            </form>

        </Panel>

    </ModelIndexLayout>
</template>

<script>
import ModelIndexLayout from "@/Layouts/ModelIndexLayout";
import Panel from "@/Components/Panel";
import FormGroup from "@/Components/FormGroup";
import Textarea from "@/Components/Textarea";
import Button from "@/Components/Button";

export default {
    components: {Button, Textarea, FormGroup, Panel, ModelIndexLayout},
    props: {
        settingOptions: Object,
        settings: Object,
    },
    data() {
        return {
            form: this.$inertia.form({
                settings: this.settings,
            }),
        }
    },
    methods: {
        submit() {
            this.form
                .transform((data) => ({
                    ...data,
                    _method: 'patch',
                }))
                .post(this.$route('admin::settings.update'));
        }
    },
}
</script>
